export const optionsStatoFarmaco = [
    { value: '', label: 'Da definire', disabled: true},
    { value: 'active', label: 'Attivo'},
    { value: 'completed', label: 'Completato'},
    { value: 'stopped', label: 'Interrotto'},
    { value: 'on-hold', label: 'Sospeso'},
];
